<template>
  <!-- 头部查询条件 -->
  <div class="table-page-search-wrapper">
    <a-form :form="form" :layout="formLayout" @submit="handleSearch">
      <a-row :gutter="gutter">
        <template v-for="(col, index) in renderItem">
          <a-col
            :key="index"
            :sm="mediaLayout.sm"
            :md="mediaLayout.md"
            :lg="mediaLayout.lg"
            :xl="mediaLayout.xl"
            :xxl="mediaLayout.xxl"
            :style="{ display: index < count ? 'block' : 'none' }"
          >
            <a-form-item :label="colon ? `${col.label}：` : col.label">
              <!--input-->
              <a-input
                v-if="col.type === 'input'"
                :size="col.size"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialForm[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                :allowClear="col.allowClear || false"
                :placeholder="col.placeholder"
                style="width: 100%"
              />
              <!--select-->
              <!--自定义方法-->
              <a-select
                v-if="col.type === 'select' && col.handleChange"
                @change="value => col.handleChange(value)"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialForm[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                style="width: 100%"
                :allowClear="col.allowClear || false"
                :placeholder="col.placeholder || '请选择'"
                :getPopupContainer="popContainerScollToFasten"
              >
                <a-select-option
                  v-for="item in col.selectList"
                  :key="item.value"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>

              <template v-if="col.slotName">
                <slot :name="col.slotName" :col="col"></slot>
              </template>

              <!--无自定义方法-->

              <a-select
                v-else-if="col.type === 'select' && !col.handleChange"
                @change="value => handleSelChange(value)"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialForm[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                style="width: 100%"
                :allowClear="col.allowClear || false"
                :placeholder="col.placeholder || '请选择'"
                :getPopupContainer="popContainerScollToFasten"
              >
                <a-select-option
                  v-for="item in col.selectList"
                  :key="item.value"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
              <!--date-picker单日期-->
              <a-date-picker
                v-if="col.type === 'datePicker'"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialForm[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                :key="col.itemName"
                :placeholder="col.placeholder"
                :format="col.format"
                :valueFormat="col.format"
                :disabled-date="col.disabledDate"
                :disabled-time="col.disabledDateTime"
                :show-time="col.showTime"
                @change="onChange"
                style="width: 100%"
                :allowClear="col.allowClear || false"
                :getCalendarContainer="popContainerScollToFasten"
              />
              <!-- 选择年 -->
              <a-date-picker
                v-if="col.type === 'yearPicker'"
                v-decorator="[
                  'year',
                  {
                    initialValue: yaerMode,
                  },
                ]"
                mode="year"
                :key="col.itemName"
                :open="yearShowOne"
                placeholder="请选择年份"
                format="YYYY"
                @openChange="handleOpenChange"
                @panelChange="handlePanelChange"
                valueFormat="YYYY"
                :disabled-date="col.disabledDate"
                :disabled-time="col.disabledDateTime"
                :show-time="col.showTime"
                style="width: 100%"
                :allowClear="col.allowClear || false"
                :getCalendarContainer="popContainerScollToFasten"
              />
              <!--range-picker双日期-->
              <a-range-picker
                v-if="col.type === 'rangePicker'"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialForm[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                :key="col.itemName"
                :disabled-date="col.disabledDate"
                :disabled-time="col.disabledRangeTime"
                :format="col.format"
                :valueFormat="col.format"
                :show-time="col.showTime"
                style="width: 100%"
                :getCalendarContainer="popContainerScollToFasten"
                :allowClear="col.allowClear || false"
              />
              <!--month-picker月份-->
              <a-month-picker
                v-if="col.type === 'monthPicker'"
                v-decorator="[
                  col.itemName,
                  {
                    initialValue: valueEmpty(initialValues[col.itemName]),
                    rules: col.rule,
                  },
                ]"
                :key="col.itemName"
                :disabled-date="col.disabledDate"
                :placeholder="col.placeholder"
                :format="col.format"
                :valueFormat="col.format"
                style="width: 100%"
                :getCalendarContainer="popContainerScollToFasten"
                :allowClear="col.allowClear || false"
              />
            </a-form-item>
          </a-col>
        </template>
        <!--查询&展开-->
        <a-col style="overflow:hidden" class="search-view-col">
          <a-form-item style="margin-bottom:0">
            <span
              class="table-page-search-submitButtons"
              :style="
                (isExpandLocal &&
                  !Number(renderItem.length % expandRenderItemCount) && {
                    float: 'right',
                    overflow: 'hidden',
                  }) ||
                  {}
              "
            >
              <a-button
                type="primary"
                html-type="submit"
                @submit="handleSubmit()"
              >
                查 询
              </a-button>
              <a-button
                @click.prevent="resetForm('searchComponent')"
                class="form__right__reset"
              >
                重 置
              </a-button>

              <slot name="slots"></slot>
              <a
                style="margin-left: 8px;"
                @click="toggle"
                v-show="isExpandShowOrNot"
              >
                {{ isExpandLocal ? '收起' : '展开' }}
                <a-icon :type="isExpandLocal ? 'up' : 'down'" />
              </a>
            </span>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- <div :class="styleIsExpand">

    </div> -->
    </a-form>
  </div>
</template>
<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'SearchView',
  comments: true,
  props: {
    advanced: {
      type: Boolean,
      default: () => {
        return false // false: 隐藏  true: 展开
      },
    },
    initialValues: {
      type: Object,
    },
    fetchSearch: {
      type: Function,
    },
    formLayout: {
      type: String,
      default: () => {
        return 'inline' //表单布局 horizontal ｜ vertical | inline
      },
    },

    isExpandShowOrNot: {
      type: Boolean,
      default: () => {
        return false //是否展开搜索框显示 or 隐藏
      },
    },
    gutter: {
      type: Number,
      default: () => {
        return 44 //Row gutter
      },
    },
    colon: {
      type: Boolean,
      default: () => {
        return true //Label冒号
      },
    },
    renderItem: {
      type: Array,
    },
    mediaLayout: {
      type: Object,
      default: () => ({
        sm: 24,
        md: 12,
        lg: 12,
        xl: 8,
        xxl: 6,
      }),
    },
    isExpand: {
      type: Boolean,
      default: () => {
        return true //是否展开
      },
    },
    expandRenderItemCount: {
      type: Number,
      default: () => {
        return 3 //收起展开后显示的item数量
      },
    },
  },
  data() {
    return {
      yearShowOne: false,
      initialForm: {},
      yaerMode: '',
      form: this.$form.createForm(this, { name: 'searchComponent' }),
      searchQuery: {}, //查询Form
      isExpandLocal: this.isExpand,
    }
  },
  computed: {
    // 展开 OR 收起——Text
    // isExpandText() {
    //   return this.isExpandLocal ? '收起' : '展开'
    // },
    // 展开 OR 收起——style

    styleIsExpand() {
      return [
        this.isExpandLocal
          ? 'ant-col-sm-24 ant-col-md-24 conditions__form__left--expand'
          : 'ant-col-sm-24 ant-col-md-12 ant-col-lg-8',
      ]
    },
    // 展开 OR 收起——col数量
    count() {
      return this.isExpandLocal
        ? this.renderItem.length
        : this.expandRenderItemCount
    },
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : formLayout === 'inline'
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {}
    },
    popContainerScollToFasten() {
      return triggerNode => triggerNode.parentNode || document.body
    },
  },
  mounted() {
    this.initialForm = cloneDeep(this.initialValues)
  },
  methods: {
    handleOpenChange() {
      this.yearShowOne = !this.yearShowOne
    },
    handlePanelChange(value) {
      this.yaerMode = moment(value).format('YYYY')
      this.yearShowOne = !this.yearShowOne
    },
    // 展开 OR 收起——切换
    toggle() {
      this.isExpandLocal = !this.isExpandLocal
    },
    // 提交Form
    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        //处理 item值为undefined时候，item值替换为空字符串 {query1=undefined} => {query1=""}
        // console.log(values)
        for (var item in values) {
          !values[item]
            ? (this.searchQuery[item] = '')
            : (this.searchQuery[item] = values[item])
        }
        this.$emit('fetchSearch', this.searchQuery)
      })
    },
    // 重置
    resetForm() {
      this.form.setFieldsValue({ year: undefined })
      this.yaerMode = ''
      this.form.resetFields()
    },
    onChange() {},
    moment,
    momentWrapDate(value, dateFormat) {
      return this.moment(value, dateFormat || 'YYYY-MM-DD')
    },
    valueEmpty: function(value) {
      return !value ? undefined : value
    },
    // select操作
    handleSelChange() {},
    setFieldsValue(key, value) {
      this.form.setFieldsValue({ [key]: value })
    },
  },
}
</script>

<style lang="less" scoped>
/* 展开 */
.conditions__form__left--expand {
  text-align: right;
  overflow: hidden;
}
/* 收起 */
.conditions__form__left--close {
  height: 74px;
}

.form__right__reset {
  margin: 0 10px;
}
.conditions__form__right--color {
  color: rgb(24, 144, 255);
}
.ant-form-inline .ant-row .ant-form-item {
  margin-bottom: 15px;
}
/deep/.ant-calendar-picker-input .ant-input {
  width: 250px;
}
.table-page-search-wrapper /deep/ .ant-form-inline .ant-form-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 24px;
  margin-right: 0;
}
.table-page-search-wrapper
  /deep/
  .ant-form-inline
  .ant-form-item
  > .ant-form-item-label {
  line-height: 32px;
  padding-right: 8px;
  width: auto;
}
.table-page-search-wrapper
  /deep/
  .ant-form-inline
  .ant-form-item
  .ant-form-item-control-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  display: inline-block;
  vertical-align: middle;
}
.table-page-search-wrapper /deep/ .ant-form-explain {
  position: absolute;
}
.table-page-search-wrapper
  /deep/
  .ant-form-inline
  .ant-row
  .ant-form-item
  .ant-form-item-label {
  line-height: 40px;
}
/deep/ .ant-form-horizontal .search-view-col {
  padding-top: 39px;
}
/deep/ .ant-form-vertical .search-view-col {
  padding-top: 29px;
}
</style>
